module.exports = __webpack_public_path__ + "static/media/do-good-feel-good.670ff29d.png";